import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import PermissionsGate from "@/Shared/PermissionsGate";
import {InertiaLink} from "@inertiajs/inertia-react";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";

const PublicCouponActionBtns = ({id, showonline, couponCategories}) => {
  const dispatch = useDispatch();

  const handleAddToCategory = () => {
    dispatch(openModal({
      modalType: 'add-to-category',
      modalProps: {
        id,
        couponCategories
      }
    }));
  }

  return (
    <div className='flex'>
        <PermissionsGate  scopes={['public-coupon']}>
        <InertiaLink className={'mr-3'} data-tip="Unpublish coupon" href={route('public.coupons.unpublished', id)}>
          <FontAwesomeIcon
            rotation={180}
            color={'red'}
            size={'lg'}
            icon={solid('arrow-right-long')}/>
        </InertiaLink>
          <button onClick={handleAddToCategory} className={'mr-3'} data-tip="Add to category">
            <FontAwesomeIcon
              rotation={180}
              color={'blue'}
              size={'lg'}
              icon={solid('arrow-left-long')}/>
          </button>

          {
            showonline === 1 ? (
              <InertiaLink data-tip="Hide coupon" href={route('public.coupons.hide', id)}>
                <FontAwesomeIcon
                  rotation={180}
                  color={'gray'}
                  size={'lg'}
                  icon={solid('eye-slash')}/>
              </InertiaLink>
            ) : (
              <InertiaLink data-tip="Show coupon" href={route('public.coupons.show', id)}>
                <FontAwesomeIcon
                  rotation={180}
                  color={'blue'}
                  size={'lg'}
                  icon={solid('eye')}/>
              </InertiaLink>
            )
          }

      </PermissionsGate>
    </div>
  );
};

export default PublicCouponActionBtns;
